import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';

import { API_BASE_URL } from '../config/api-base-url.token';
import type {
  CreateWebhookPayload,
  CreateWebhookResponse,
  UpdateWebhookPayload,
  UpdateWebhookStatePayload,
  VerifyWebhookUrlPayload,
  VerifyWebhookUrlResponse,
  WebhookListResponse,
  WebhookSummary,
} from '../models/webhook.models';

@Injectable({ providedIn: 'root' })
export class WebhookApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  listWebhooks(): Observable<WebhookListResponse> {
    return this.http.get<WebhookListResponse>(`${this.baseUrl}/webhooks`);
  }

  verifyWebhookUrl(payload: VerifyWebhookUrlPayload): Observable<VerifyWebhookUrlResponse> {
    return this.http.post<VerifyWebhookUrlResponse>(`${this.baseUrl}/webhooks/verify`, payload);
  }

  createWebhook(payload: CreateWebhookPayload): Observable<CreateWebhookResponse> {
    return this.http.post<CreateWebhookResponse>(`${this.baseUrl}/webhooks`, payload);
  }

  updateWebhook(id: string, payload: UpdateWebhookPayload): Observable<WebhookSummary> {
    return this.http.patch<WebhookSummary>(`${this.baseUrl}/webhooks/${id}`, payload);
  }

  updateWebhookState(id: string, payload: UpdateWebhookStatePayload): Observable<WebhookSummary> {
    return this.http.patch<WebhookSummary>(`${this.baseUrl}/webhooks/${id}/state`, payload);
  }

  deleteWebhook(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/webhooks/${id}`);
  }
}
